import { getIdProtect, getPaymentProtectionInsurance } from '@/api/SE/addonProducts';
import {
  createApplicant,
  getApplicant,
  updateApplicant,
  updateApplicantAddonProducts,
  updateApplicantEmploymentStatus,
  updateApplicantFinances,
  updateApplicantLiving,
  updateApplicantLoanPurpose,
} from '@/api/SE/applicants';
import { getBankIdStatus, retryBankId } from '@/api/SE/bankId';
import {
  acceptOffer as creditAcceptOffer,
  createApplication,
  createOpenBankingUrl,
  declineOffer as creditDeclineOffer,
  getApplication,
  initiateIncomeVerification,
  signOffer as creditSignOffer,
  startApplicationAssessment,
} from '@/api/SE/credit';
import {
  acceptOffer as loanAcceptOffer,
  declineOffer as loanDeclineOffer,
  getFeaturesSteps,
  getWithdrawalStatus,
  signOffer as loanSignOffer,
  signPartnerOffer,
} from '@/api/SE/loan';
import { getLoginData, initiateLogin } from '@/api/SE/login';
import {
  abortDirectPayment,
  getDirectPayment,
  getDirectPaymentStatus,
  initiateDirectPayment,
  selectAccount,
  updateAccount,
} from '@/api/SE/paymentProvider';

const SE = {
  addonProducts: { getIdProtect, getPaymentProtectionInsurance },
  applicants: {
    createApplicant,
    getApplicant,
    updateApplicant,
    updateApplicantAddonProducts,
    updateApplicantEmploymentStatus,
    updateApplicantFinances,
    updateApplicantLiving,
    updateApplicantLoanPurpose,
  },
  bankId: { getBankIdStatus, retryBankId },
  credit: {
    acceptOffer: creditAcceptOffer,
    createApplication,
    createOpenBankingUrl,
    declineOffer: creditDeclineOffer,
    getApplication,
    initiateIncomeVerification,
    signOffer: creditSignOffer,
    startApplicationAssessment,
  },
  loan: {
    acceptOffer: loanAcceptOffer,
    declineOffer: loanDeclineOffer,
    getFeaturesSteps,
    getWithdrawalStatus,
    signOffer: loanSignOffer,
    signPartnerOffer,
  },
  login: { getLoginData, initiateLogin },
  paymentProvider: {
    abortDirectPayment,
    getDirectPayment,
    getDirectPaymentStatus,
    initiateDirectPayment,
    selectAccount,
    updateAccount,
  },
};

export default SE;
